/* eslint-disable @typescript-eslint/no-explicit-any */

export const parseJsonSafe = <R = any>(json: string, defaultValue: R): R => {
  try {
    return JSON.parse(json);
  } catch {
    return defaultValue;
  }
};

export const parseJsonObjectSafe = <R extends object = Record<string, any>>(
  json: string,
  defaultValue: R = Object.create(null),
): R => {
  const data = parseJsonSafe<R>(json, defaultValue);
  return typeof data === 'object' && data !== null ? data : defaultValue;
};
